<template>
  <section class="content-panel">
    <div class="section-head">
      <div>
        <h2>设备与分组</h2>
        <p>按客户查看设备归属及风险状态</p>
      </div>
      <CustomerRemoteSelect
        :model-value="admin.selectedCustomerId.value"
        :token="admin.token.value"
        placeholder="选择客户"
        width="220px"
        @change="onCustomerChange"
        @select="onCustomerSelect"
      />
    </div>

    <el-tabs>
      <el-tab-pane :label="`设备 (${admin.devices.value.length})`">
        <el-table :data="admin.devices.value" stripe>
          <el-table-column prop="deviceId" label="设备标识" min-width="220" show-overflow-tooltip />
          <el-table-column label="所属分组" min-width="130">
            <template #default="{ row }">{{ admin.groupName(row.groupId) }}</template>
          </el-table-column>
          <el-table-column label="风险状态" width="120">
            <template #default="{ row }">
              <el-tag :type="riskType(row.riskStatus)" effect="light">{{ row.riskStatus || 'UNKNOWN' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="lastLoginAt" label="最近登录" min-width="180">
            <template #default="{ row }">{{ row.lastLoginAt || '-' }}</template>
          </el-table-column>
          <template #empty>
            <el-empty :description="admin.selectedCustomerId.value ? '该客户暂无设备' : '请先选择客户'" />
          </template>
        </el-table>
      </el-tab-pane>

      <el-tab-pane :label="`分组 (${admin.groups.value.length})`">
        <el-table :data="admin.groups.value" stripe>
          <el-table-column prop="name" label="分组名称" min-width="180" />
          <el-table-column prop="remark" label="备注">
            <template #default="{ row }">{{ row.remark || '-' }}</template>
          </el-table-column>
          <template #empty>
            <el-empty :description="admin.selectedCustomerId.value ? '该客户暂无分组，App 登录填写分组名后会自动创建' : '请先选择客户'" />
          </template>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </section>
</template>

<script setup>
import CustomerRemoteSelect from '@/components/CustomerRemoteSelect.vue'

const props = defineProps({ admin: Object })

const riskType = (status) => ({
  SAFE: 'success',
  PASS: 'success',
  RISK: 'danger',
  BLOCKED: 'danger'
}[status] || 'info')

function onCustomerSelect(item) {
  if (item) props.admin.rememberCustomers([item])
}

function onCustomerChange(id) {
  props.admin.selectCustomer(id || null)
}
</script>
